export const BUTTON = {
  BUY_NOW: "اشتري الآن",
};

export const ADDRESS = {
  ENTER_INFO: "قم بإضافة عنوانك",
  ENTER_INFO_DESC: "يجب عليك إضافة تفاصيل عنوانك لتتمكن من المتابعة",
  PROCEED: "تقدم",
};

export const USER = {
  ENTER_INFO: "أضف اسمك",
  ENTER_INFO_DESC: "يجب إضافة اسمك للمتابعة",
  PROCEED: "تقدم",
};
